var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { AccordionSet, Accordion, Button } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { RecekTextField, RecekSelect } from "./inputs";
import { PublisherOwnerEnum } from "../types/Api";
import { fetchRegions } from "../api/regionService";
import { validatePublisherPrefix } from "../utils/validationUtils";
export var PublisherFilters = function (_a) {
    var _b;
    var filters = _a.filters, onFilterChange = _a.onFilterChange, onApplyFilters = _a.onApplyFilters, hasUnappliedChanges = _a.hasUnappliedChanges;
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    var ky = useOkapiKy();
    var prefixValidation = validatePublisherPrefix(filters.publisherPrefix);
    var hasPrefixValidationError = !prefixValidation.isValid;
    var regionsData = useQuery(["regions"], function () {
        return fetchRegions(ky);
    }).data;
    return (React.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            onApplyFilters();
        } },
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.name",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-legaldeposits.filter.name", showLabel: false, value: filters.name, onChange: function (e) { return onFilterChange("name", e.target.value); }, placeholder: formatMessage({
                        id: "ui-br-legaldeposits.filter.name.placeholder",
                    }) })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.owner",
                }), separator: false },
                React.createElement(RecekSelect, { labelId: "ui-br-legaldeposits.filter.owner", showLabel: false, value: filters.owner, onChange: function (e) {
                        return onFilterChange("owner", e.target.value);
                    }, dataOptions: __spreadArray([
                        {
                            value: "",
                            label: formatMessage({
                                id: "ui-br-legaldeposits.filter.select.all",
                            }),
                        }
                    ], Object.values(PublisherOwnerEnum).map(function (owner) { return ({
                        value: owner,
                        label: formatMessage({
                            id: "ui-br-legaldeposits.publishers.owner.".concat(owner),
                        }),
                    }); }), true) })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.region",
                }), separator: false },
                React.createElement(RecekSelect, { labelId: "ui-br-legaldeposits.filter.region", showLabel: false, value: filters.regionId, onChange: function (e) {
                        return onFilterChange("regionId", e.target.value);
                    }, dataOptions: __spreadArray([
                        {
                            value: "",
                            label: formatMessage({
                                id: "ui-br-legaldeposits.filter.select.all",
                            }),
                        }
                    ], ((_b = regionsData === null || regionsData === void 0 ? void 0 : regionsData.items) !== null && _b !== void 0 ? _b : []).map(function (region) {
                        var _a, _b;
                        return ({
                            value: (_a = region.id) !== null && _a !== void 0 ? _a : "",
                            label: (_b = region.name) !== null && _b !== void 0 ? _b : "",
                        });
                    }), true) })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-legaldeposits.filter.publisherPrefix",
                }), separator: false },
                React.createElement(RecekTextField, { labelId: "ui-br-legaldeposits.filter.publisherPrefix", showLabel: false, value: filters.publisherPrefix, onChange: function (e) { return onFilterChange("publisherPrefix", e.target.value); }, placeholder: formatMessage({
                        id: "ui-br-legaldeposits.filter.publisherPrefix.placeholder",
                    }), error: prefixValidation.hasInvalidChars
                        ? formatMessage({
                            id: "ui-br-legaldeposits.filter.publisherPrefix.invalidFormat",
                        })
                        : prefixValidation.isTooShort
                            ? formatMessage({
                                id: "ui-br-legaldeposits.filter.publisherPrefix.minLength",
                            })
                            : undefined }))),
        React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, type: "submit", disabled: !hasUnappliedChanges || hasPrefixValidationError },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.apply" }))));
};
